import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'subDiget' })
export class SubDigetPipe implements PipeTransform {
    transform(value: any, arg: string): any {
        value = typeof value === 'number' ? value : parseFloat(value); //确保value为数字
        value = isNaN(value) ? 0 : value;
        let parNum = parseInt(arg); //保留数位
        let flag = arg.length == parNum.toString().length ? false : true; //是否补零
        let str = value.toString(); //
        let index = str.indexOf('.') === -1 ? 0 : str.indexOf('.'); //查找小数点下标，确定位置
        if (flag) {
            //补零情况
            if (index == 0) {
                //value为整数
                str += '.';
                for (let i = 0; i < parNum; i++) {
                    str += '0';
                }
                return str;
            } else {
                //value不为整数
                let len = parNum - (str.length - (index + 1));
                if (len > 0) {
                    for (let i = 0; i < len; i++) {
                        str += '0';
                    }
                    return str;
                } else {
                    str = str.slice(0, index + 1 + parNum);
                    return str;
                }
            }
        } else {
            //不补零
            if (value > 0) {
                //value正数
                str = Math.floor(value * (Math.pow(10, parNum))) / Math.pow(10, parNum);
                return str;
            } else {
                //value为负数
                if (parNum == 0) {
                    if (index == 0) {
                        str = str.slice(0, str.length);
                        return str;
                    } else {
                        str = str.slice(0, index + parNum);
                        if (str == '-0') {
                            str = 0;
                        }
                        return str;
                    }
                } else {
                    if (index == 0) {
                        str = str.slice(0, str.length);
                        return str;
                    } else {
                        str = str.slice(0, index + 1 + parNum);
                        str = parseFloat(str);
                        return str;
                    }
                }
            }
        }
    }
}


// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./node_modules/angular2-template-loader!./node_modules/tslint-loader??ref--7-0!./src/pipes/subDiget.pipe.ts